// src/components/CategorySelector.jsx - GELİŞMİŞ KATEGORİ SEÇİCİ
import React, { useState } from 'react';
import { X, Search, ChevronRight, Check } from 'lucide-react';

export function CategorySelector({ value, onChange, categoryConfig, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMain, setSelectedMain] = useState(null);
  const [hoveredMain, setHoveredMain] = useState(null);

  const mainCategories = Object.keys(categoryConfig);

  // Arama filtresi
  const filteredMainCategories = mainCategories.filter(mainCat => {
    if (!searchTerm) return true;
    
    const mainMatch = mainCat.toLowerCase().includes(searchTerm.toLowerCase());
    const subMatch = categoryConfig[mainCat].subcategories && 
      Object.keys(categoryConfig[mainCat].subcategories).some(subCat => 
        subCat.toLowerCase().includes(searchTerm.toLowerCase())
      );
    
    return mainMatch || subMatch;
  });

  const handleMainSelect = (mainCat) => {
    // Eğer alt kategori yoksa direkt seç ve kapat
    if (!categoryConfig[mainCat].subcategories || Object.keys(categoryConfig[mainCat].subcategories).length === 0) {
      onChange(mainCat);
      if (onClose) onClose();
    } else {
      setSelectedMain(mainCat);
    }
  };

  const handleSubSelect = (mainCat, subCat) => {
    onChange(`${mainCat} > ${subCat}`);
    if (onClose) onClose();
  };

  const isSelected = (mainCat, subCat = null) => {
    if (!value) return false;
    if (subCat) {
      return value === `${mainCat} > ${subCat}`;
    }
    return value === mainCat || value?.startsWith(`${mainCat} >`);
  };

  return (
    <div className="category-selector-overlay">
      <div className="category-selector-modal">
        {/* Header */}
        <div className="selector-header">
          <h3>📦 Kategori Seçin</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        {/* Search */}
        <div className="selector-search">
          <Search size={20} />
          <input
            type="text"
            placeholder="Kategori ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>

        {/* Content */}
        <div className="selector-content">
          {/* Ana Kategoriler */}
          <div className="main-categories-panel">
            <div className="panel-title">Ana Kategoriler</div>
            <div className="categories-list">
              {filteredMainCategories.map(mainCat => {
                const data = categoryConfig[mainCat];
                const hasSubcategories = data.subcategories && Object.keys(data.subcategories).length > 0;
                const selected = isSelected(mainCat);
                const hovered = hoveredMain === mainCat || selectedMain === mainCat;

                return (
                  <button
                    key={mainCat}
                    className={`category-item ${selected ? 'selected' : ''} ${hovered ? 'hovered' : ''}`}
                    onClick={() => handleMainSelect(mainCat)}
                    onMouseEnter={() => {
                      if (hasSubcategories) {
                        setHoveredMain(mainCat);
                        setSelectedMain(mainCat);
                      }
                    }}
                  >
                    <span className="category-emoji">{data.emoji}</span>
                    <span className="category-name">{mainCat}</span>
                    {hasSubcategories && (
                      <ChevronRight size={18} className="chevron" />
                    )}
                    {selected && !hasSubcategories && (
                      <Check size={18} className="check-icon" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Alt Kategoriler */}
          {selectedMain && categoryConfig[selectedMain]?.subcategories && (
            <div className="sub-categories-panel">
              <div className="panel-title">
                {categoryConfig[selectedMain].emoji} {selectedMain}
              </div>
              <div className="categories-list">
                {Object.entries(categoryConfig[selectedMain].subcategories).map(([subCat, subData]) => {
                  const selected = isSelected(selectedMain, subCat);

                  return (
                    <button
                      key={subCat}
                      className={`category-item ${selected ? 'selected' : ''}`}
                      onClick={() => handleSubSelect(selectedMain, subCat)}
                    >
                      <span className="category-emoji">{subData.emoji}</span>
                      <span className="category-name">{subCat}</span>
                      {selected && (
                        <Check size={18} className="check-icon" />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Boş Alt Panel (görsel denge için) */}
          {!selectedMain && (
            <div className="sub-categories-panel empty">
              <div className="empty-message">
                <span style={{ fontSize: '48px', opacity: 0.3 }}>👈</span>
                <p>Bir ana kategori seçin</p>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="selector-footer">
          <button className="btn-clear" onClick={() => {
            onChange('');
            if (onClose) onClose();
          }}>
            Kategoriyi Temizle
          </button>
          <div className="footer-info">
            {value && (
              <span className="current-selection">
                Seçili: <strong>{value}</strong>
              </span>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .category-selector-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 1rem;
        }

        .category-selector-modal {
          background: white;
          border-radius: 16px;
          max-width: 900px;
          width: 100%;
          max-height: 80vh;
          display: flex;
          flex-direction: column;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        .selector-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 2rem;
          border-bottom: 2px solid #e9ecef;
        }

        .selector-header h3 {
          margin: 0;
          font-size: 20px;
          color: #2B2B2B;
        }

        .close-btn {
          background: none;
          border: none;
          padding: 0.5rem;
          cursor: pointer;
          color: #868e96;
          transition: all 0.2s;
          border-radius: 8px;
        }

        .close-btn:hover {
          background: #f8f9fa;
          color: #E5332A;
        }

        .selector-search {
          padding: 1.5rem 2rem;
          border-bottom: 2px solid #e9ecef;
          display: flex;
          align-items: center;
          gap: 1rem;
          background: #f8f9fa;
        }

        .selector-search input {
          flex: 1;
          padding: 0.75rem 1rem;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          font-size: 14px;
          background: white;
          transition: all 0.2s;
        }

        .selector-search input:focus {
          outline: none;
          border-color: #E5332A;
          box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
        }

        .selector-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          flex: 1;
          overflow: hidden;
        }

        .main-categories-panel,
        .sub-categories-panel {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .main-categories-panel {
          border-right: 2px solid #e9ecef;
        }

        .sub-categories-panel.empty {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8f9fa;
        }

        .empty-message {
          text-align: center;
          color: #868e96;
        }

        .empty-message p {
          margin: 1rem 0 0;
          font-size: 14px;
        }

        .panel-title {
          padding: 1rem 1.5rem;
          font-size: 13px;
          font-weight: 700;
          color: #868e96;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          background: #f8f9fa;
          border-bottom: 1px solid #e9ecef;
        }

        .categories-list {
          flex: 1;
          overflow-y: auto;
          padding: 0.5rem;
        }

        .categories-list::-webkit-scrollbar {
          width: 8px;
        }

        .categories-list::-webkit-scrollbar-track {
          background: #f8f9fa;
        }

        .categories-list::-webkit-scrollbar-thumb {
          background: #dee2e6;
          border-radius: 4px;
        }

        .categories-list::-webkit-scrollbar-thumb:hover {
          background: #adb5bd;
        }

        .category-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem 1.5rem;
          border: 2px solid transparent;
          border-radius: 10px;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          margin-bottom: 0.5rem;
          width: 100%;
          text-align: left;
        }

        .category-item:hover {
          background: #f8f9fa;
          border-color: #e9ecef;
        }

        .category-item.hovered {
          background: #fff5f5;
          border-color: #E5332A;
        }

        .category-item.selected {
          background: linear-gradient(135deg, #fff5f5, #ffe5e5);
          border-color: #E5332A;
          box-shadow: 0 2px 8px rgba(229, 51, 42, 0.15);
        }

        .category-emoji {
          font-size: 28px;
          line-height: 1;
          flex-shrink: 0;
        }

        .category-name {
          flex: 1;
          font-size: 15px;
          font-weight: 600;
          color: #2B2B2B;
        }

        .chevron {
          color: #868e96;
          flex-shrink: 0;
        }

        .check-icon {
          color: #E5332A;
          flex-shrink: 0;
        }

        .selector-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 2rem;
          border-top: 2px solid #e9ecef;
          background: #f8f9fa;
        }

        .btn-clear {
          padding: 0.75rem 1.5rem;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          background: white;
          color: #495057;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }

        .btn-clear:hover {
          border-color: #E5332A;
          color: #E5332A;
          background: #fff5f5;
        }

        .footer-info {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .current-selection {
          font-size: 13px;
          color: #495057;
        }

        .current-selection strong {
          color: #E5332A;
          font-weight: 700;
        }

        @media (max-width: 768px) {
          .category-selector-modal {
            max-width: 100%;
            max-height: 90vh;
            margin: 1rem;
          }

          .selector-content {
            grid-template-columns: 1fr;
          }

          .main-categories-panel {
            border-right: none;
            border-bottom: 2px solid #e9ecef;
          }

          .sub-categories-panel {
            display: ${selectedMain ? 'flex' : 'none'};
          }

          .category-emoji {
            font-size: 24px;
          }

          .category-item {
            padding: 0.875rem 1rem;
          }
        }
      `}</style>
    </div>
  );
}

export default CategorySelector;